import Api from './SinglePhotographerInvoiceApi';
import * as types from './SinglePhotographerInvoiceActionTypes';

function getPhotographerInvoiceFilterSuccess(filter: any) {
    return {
        type: types.GET_PHOTOGRAPHER_INVOICES_FILTER_SUCCESS,
        result: filter
    };
}

export function getPhotographerInvoiceFilter(employedPhotographers: boolean) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getPhotographerInvoiceFilter(employedPhotographers).then((result: any) => {
            dispatch(getPhotographerInvoiceFilterSuccess(result));
        });
}

function getPhotographerInvoiceSuccess(invoice: any) {
    return { type: types.GET_PHOTOGRAPHER_INVOICE_SUCCESS, result: invoice };
}

export function getPendingInvoice(
    photographerId: number,
    invoiceNumber: string,
    year: number,
    month: number
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getPendingInvoice(photographerId, invoiceNumber, year, month).then((result: any) => {
            dispatch(getPhotographerInvoiceSuccess(result));
        });
}

export function savePendingInvoice(invoiceNumber: string, checksum: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.savePendingInvoice(invoiceNumber, checksum).then((result: any) => {
            dispatch(getListsSuccess(result));
        });
}

export function getPreviewInvoice(photographerId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getPreviewInvoice(photographerId).then((result: any) => {
            dispatch(getPhotographerInvoiceSuccess(result));
        });
}

export function getHistoricInvoice(photographerId: number, invoiceId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getHistoricInvoice(photographerId, invoiceId).then((result: any) => {
            dispatch(getPhotographerInvoiceSuccess(result));
        });
}

export function getHistoricEmployedInvoice(photographerId: number, year: number, month: number) {
    return (dispath: (result: any) => void) =>
        Api.getHistoricEmployedInvoice(photographerId, year, month).then((result: any) => {
            dispath(getPhotographerInvoiceSuccess(result));
        });
}

function getListsSuccess(list: any) {
    return { type: types.GET_PHOTOGRAPHER_INVOICE_LISTS_SUCCESS, result: list };
}

export function getLists(photographerId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getLists(photographerId).then((result: any) => {
            dispatch(getListsSuccess(result));
        });
}

export function clearFilterPlaceholder(): any {
    return (dispatch: (result: any) => void) =>
        dispatch({
            type: types.CLEAR_PHOTOGRAPHER_INVOICES_FILTER_PLACEHOLDER
        });
}

export function clearState(): any {
    return (dispatch: (result: any) => void) =>
        dispatch({ type: types.CLEAR_PHOTOGRAPHER_INVOICES_STATE });
}

export function rejectPendingInvoice(
    photographerId: number,
    year: number,
    month: number,
    day: number,
    rejectMessage: string
) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.rejectPendingInvoice(photographerId, year, month, day, rejectMessage).then(
            (result: any) => {
                dispatch(getListsSuccess(result));
            }
        );
}

export function clearListsFromState(): any {
    return (dispatch: (result: any) => void) =>
        dispatch({ type: types.CLEAR_PHOTOGRAPHER_INVOICE_LISTS_STATE });
}

export function getRejectedInvoice(
    photographerId: number,
    year: number,
    month: number,
    day: number
): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getRejectedInvoice(photographerId, year, month, day).then((result: any) => {
            dispatch(getPhotographerInvoiceSuccess(result));
        });
}

export function unlockRejectedInvoice(
    photographerId: number,
    year: number,
    month: number,
    day: number
): any {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.unlockRejectedInvoice(photographerId, year, month, day);
}
